/**
 * JSON Fetch with the CSRF token added. This wrapper also updates the `aha.active` count
 * so that integration tests can wait until all `fetch` requests have completed.
 */
export const jsonFetch = async (
  url: string,
  { headers, ...options }: RequestInit
) => {
  // Track active requests for tests
  if (typeof window !== 'undefined' && window.aha) {
    window.aha.active++;
  }

  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken(),
      ...headers,
    },
  }).finally(() => {
    if (typeof window !== 'undefined' && window.aha) {
      window.aha.active--;
    }
  });
};

/**
 * Perform a fetch against a rails action that returns a script (.js.erb) and execute the script.
 */
export const scriptFetch = async (
  url: string,
  options?: RequestInit
): Promise<void> => {
  const headers = options?.headers ?? {};

  // Track active requests for tests
  if (typeof window !== 'undefined' && window.aha) {
    window.aha.active++;
  }

  const res = await fetch(url, {
    ...options,
    headers: {
      Accept: 'text/javascript',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': csrfToken(),
      ...headers,
    },
  }).finally(() => {
    if (typeof window !== 'undefined' && window.aha) {
      window.aha.active--;
    }
  });
  if (!res.ok) {
    throw new Error();
  }
  const text = await res.text();
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.appendChild(document.createTextNode(text));
  document.body.appendChild(script);
};
